























import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class AdminAccountError extends Vue {
  private closePopup() {
    window.close();
  }
}
